/**
 * @namespace BX.UI.Dialogs
 */
export default class MessageBoxButtons {
	static NONE = "none";

	static OK = "ok";
	static CANCEL = "cancel";
	static YES = "yes";
	static NO = "no";

	static OK_CANCEL = "ok_cancel";
	static YES_NO = "yes_no";
	static YES_CANCEL = "yes_cancel";
	static YES_NO_CANCEL = "yes_no_cancel";
}